var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"text-primary font-bold font-display",class:_vm.textSize},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }